// BL-2146 (PRJ-75 sweep P3, P1-S7) — the one Zod validator for a lot's
// category: membership in `DEFAULT_CATEGORIES`, the code-list
// `auction_lots.category_id` slug (BUG-1089). Shared by Edit lots' bulk
// `categoryId` (`lot-batch.ts`) and the lot PATCH's single-lot one
// (`lot-patch.ts`), so an off-list value (a typo, a stray HTML string,
// whitespace) is a 400 `fieldErrors.categoryId` on both doors instead of a
// silently stored value every screen and the export then render blank.
//
// Client-bundle-safe: pure Zod, no `server-only` / `node:*`.

import { z } from '@auctogon/core/zod';

import { DEFAULT_CATEGORIES } from '../isomorphic/categories';

const KNOWN_CATEGORY_IDS = new Set(DEFAULT_CATEGORIES.map((c) => c.id));

/** The refusal `EditLotsFieldsSchema.categoryId` / `LotPatchRequestSchema.categoryId` share. */
export const LOT_CATEGORY_ID_INVALID_MESSAGE = 'Choose a category';

/**
 * A lot's category id — must be one of `DEFAULT_CATEGORIES`'s slugs (active or
 * not: a lot already carrying a retired category may still resave it).
 */
export const LotCategoryIdSchema = z
  .string()
  .refine((id) => KNOWN_CATEGORY_IDS.has(id), LOT_CATEGORY_ID_INVALID_MESSAGE);
